import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "../ui/sonner";
import { Button } from "../ui/button";
import { ReasonModal } from "./ReasonModal";

export const VerificationActions = ({ photographerId, onDone, compact = false }) => {
  const [modal, setModal] = useState(null); // "reject" | "request-info" | "suspend"

  const approve = async () => {
    try {
      await api.post(`/admin/verifications/${photographerId}/approve`);
      toast.success("Photographer approved");
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't approve");
    }
  };

  const submitModal = async (reason) => {
    const endpoint = { reject: "reject", "request-info": "request-info", suspend: "suspend" }[modal];
    try {
      await api.post(`/admin/verifications/${photographerId}/${endpoint}`, { reason });
      toast.success("Updated");
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't update");
    }
  };

  const MODAL_COPY = {
    reject: { title: "Reject this application", description: "This reason will be shared with the photographer.", confirmLabel: "REJECT" },
    "request-info": { title: "Request more information", description: "Describe exactly what's needed. The photographer will see this on their dashboard.", confirmLabel: "SEND REQUEST" },
    suspend: { title: "Suspend hosting privileges", description: "This revokes the photographer's ability to publish new sessions. Their account login is not affected.", confirmLabel: "SUSPEND" },
  };

  return (
    <>
      <div className={`flex gap-2 ${compact ? "flex-wrap" : ""}`} data-testid={`verification-actions-${photographerId}`}>
        <Button data-testid={`approve-verification-${photographerId}`} onClick={approve} className="bg-stranger-orange hover:bg-orange-600 text-clean-white font-bold rounded-full text-xs">
          APPROVE
        </Button>
        <Button data-testid={`request-info-verification-${photographerId}`} onClick={() => setModal("request-info")} variant="outline" className="rounded-full font-bold text-xs">
          REQUEST INFO
        </Button>
        <Button data-testid={`reject-verification-${photographerId}`} onClick={() => setModal("reject")} variant="outline" className="rounded-full font-bold text-xs text-red-600">
          REJECT
        </Button>
        <Button data-testid={`suspend-verification-${photographerId}`} onClick={() => setModal("suspend")} variant="outline" className="rounded-full font-bold text-xs text-red-600">
          SUSPEND
        </Button>
      </div>
      <ReasonModal open={!!modal} onOpenChange={(v) => !v && setModal(null)} onConfirm={submitModal} {...(modal ? MODAL_COPY[modal] : {})} />
    </>
  );
};
